window.HoadMotion = {
  reducedMotion: function () {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  },
  canAnimate: function () {
    return (
      document.body.classList.contains('animations-true') &&
      typeof window.gsap !== 'undefined' &&
      !window.HoadMotion.reducedMotion()
    );
  },
  isMobile: function () {
    return window.matchMedia('(max-width: 767px)').matches;
  }
};
